import TableControls from "@/components/table/TableControls"
import { defineComponent, type ReactiveComponent } from "vue-utils"
import { useVtsLogStore } from "./store"
import VtsTable from "./table/VtsTable"

const VtsResultsDisplay: ReactiveComponent = () => {
	const store = useVtsLogStore()

	return () => {
		const result = store.getResults()
		if (result.globalTotal === 0) {
			return <p>There are no VTS logs recorded in the system.</p>
		}
		if (result.totalItems === 0) {
			return <p>No entries match your selected criteria.</p>
		}
		return (
			<>
				<VtsTable />
				<TableControls
					entityName="VTS Logs"
					page={store.requestOptions.page}
					pageSize={store.requestOptions.pageSize}
					totalItems={result.totalItems}
					totalPages={result.totalPages}
					setPage={(page) => (store.requestOptions.page = page)}
					setPageSize={(pageSize) => (store.requestOptions.pageSize = pageSize)}
				/>
			</>
		)
	}
}

export default defineComponent(VtsResultsDisplay)
